<template>
    <avue-crud
            :option="option"
            :data="data"
            :page="page"
            @refresh-change="refreshChange"
            @search-change="searchChange"
            @row-save="store"
            @row-update="update"
            @row-del="del"
            @size-change="sizeChange"
            @current-change="currentChange"
            :upload-before="uploadBefore"
            ref="crud"
    >
        <template slot-scope="scope" slot="menu">
        <el-button icon="el-icon-edit" size="small" type="text" v-if="scope.row.is_reply===1" @click.stop="handleReply(scope.row,scope.index)">回复</el-button>
    </template>

        <template slot-scope="scope" slot="is_reply">
            <span v-if="scope.row.is_reply===1" style="color: crimson">未回复</span>
            <span v-if="scope.row.is_reply===2" style="color: green">已回复</span>
        </template>
    </avue-crud>
</template>
<script>
  import curd from './Base/Crud'

  export default {
    mixins: [curd],
    data() {
      return {
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: true, // 增加按钮显隐
          addBtnText:'新增通知', // 新增按钮文案
          editBtn: false, // 修改按钮显隐
          editBtnText: '回复',
          delBtn: false, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '活动标题',
              overHidden: true,
              prop: 'title',
              span: 24,
              align: 'left',
              rules: [{
                type: 'string', required: true, message: '活动标题不能为空', trigger: 'blur'
              }]
            },
            {
              label: '活动时间',
              prop: 'time',
              type: 'datetime',
              valueFormat: 'yyyy-MM-dd',
              span: 24,
              rules: [{
                type: 'string', required: true, message: '活动时间不能为空', trigger: 'blur'
              }]
            },
            {
              label: '活动地址',
              prop: 'address',
              overHidden: true,
              span: 24,
              rules: [{
                type: 'string', required: true, message: '活动地址不能为空', trigger: 'blur'
              }]
            },
            {
              label: '限报人数',
              prop: 'max_num',
              span: 24,
              value: 100
            },
            {
              label: '已报人数',
              prop: 'current_num',
              display: false,
              span: 24
            }
          ]
        }
      }
    },
    methods: {
      // 回复
      handleReply (row, index) {
        this.$refs.crud.rowEdit(row, index)
      }
    }
  }
</script>
